import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { uiActions } from "../../store";
import styles from "./EmailShare.module.css";
import PopUpModal from "../PopUpModal/PopUpModal";
import FormInput from "../FormInput/FormInput";
import FormTextarea from "../FormTextarea/FormTextarea";
import emailIcon from './assets/email.svg';
import GenerateShareLink from "../GenerateShareLink/GenerateShareLink";

export default function EmailShareModal() {
    const [formValidity, setFormValidity] = useState({});
    const [formData, setFormData] = useState({
        fromName: '',
        fromEmail: '',
        toName: '',
        toEmail: '',
        body: ''
    });

    const shareText = useSelector((state) => state.ui.socialShareText);
    const shareLink = GenerateShareLink();

    const checkFormValidity = () => {
        for (let key in formValidity) {
            if (!formValidity[key]) {
                document.getElementById(key).focus();
                document.getElementById(key).blur();
                return false;
            }
        }
        return true;
    };

    const dispatch = useDispatch();
    const emailModalStatus = useSelector((state) => state.ui.emailModalActive);

    const handleClose = () => {
        dispatch(uiActions.setEmailModalActive(false));
        dispatch(uiActions.setShareModalActive(true));
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        if(checkFormValidity()){
            const data = new FormData(event.target);
            const dataObj = data.entries();
            const formData = {};
            dataObj.forEach((arry, key) => {
                formData[arry[0]] = arry[1]
            });
            console.log(formData)
            try {
                const response = await fetch('/services/email.ashx', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded' // Ensure correct content type
                    },
                    body: new URLSearchParams(formData)
                });

                if (response.ok) {
                    // Handle success
                    console.log('Form submitted successfully');
                    console.log(response);
                    handleClose();
                } else {
                    // Handle error
                    console.error('Form submission failed');
                }
            } catch (error) {
                console.error('Error submitting form:', error);
            }
        }
    };


    return (
        <>
            {emailModalStatus &&
                <PopUpModal handleClose={handleClose}>
                    <div className={styles.container}>
                        <h1>Share via Email</h1>
                        <form onSubmit={handleSubmit}>
                            <FormInput
                                id="fromName"
                                name="fromName"
                                label="Your Name"
                                type="text"
                                required={true}
                                errorMsg={"Only letters and spaces allowed"}
                                pattern={/^[A-Za-z\s]+$/}
                                setFormValidity={setFormValidity}
                            />
                            <FormInput
                                id="fromEmail"
                                name="fromEmail"
                                label="Your Email"
                                type="email"
                                required={true}
                                errorMsg={"Enter valid email address. ex - someone@example.com"}
                                pattern={/^[\w.-]+@([\w-]+\.)+[\w-]{2,4}$/}
                                setFormValidity={setFormValidity}
                            />
                            <FormInput
                                id="toName"
                                name="toName"
                                label="Friend's Name"
                                type="text"
                                required={true}
                                errorMsg={"Only letters and spaces allowed"}
                                pattern={/^[A-Za-z\s]+$/}
                                setFormValidity={setFormValidity}
                            />
                            <FormInput
                                id="toEmail"
                                name="toEmail"
                                label="Friend's Email"
                                type="email"
                                required={true}
                                errorMsg={"Enter valid email address. ex - someone@example.com"}
                                pattern={/^[\w.-]+@([\w-]+\.)+[\w-]{2,4}$/}
                                setFormValidity={setFormValidity}
                            />
                            <FormTextarea
                                id="body"
                                name="body"
                                label="Add your message"
                                defaultText={shareText + '\n' + shareLink}
                                required={true}
                                errorMsg={"Only letters and spaces allowed"}
                                pattern={/.*/}
                                setFormValidity={setFormValidity}
                            />
                            <button type="submit">Send</button>
                        </form>
                    </div>
                </PopUpModal>
            }
        </>
    );
}

const EmailShareLink = () => {
    const dispatch = useDispatch();

    const handleClick = () => {
        dispatch(uiActions.setShareModalActive(false));
        dispatch(uiActions.setEmailModalActive(true));
    };

    return (
        <button className={styles.shareEmailBtn} onClick={handleClick} aria-label="Open Share Modal">
            <img src={emailIcon} className={styles.emailSvg} alt="open share modal icon" />
        </button>
    );
};

export {EmailShareModal, EmailShareLink};
